import React, { useEffect, useState } from "react";
import {Link, Outlet, useNavigate} from "react-router-dom";
import {
    chat,
    logo,
    noti,
    notification,
    preloader,
    profileImg,
    singleProfile,
} from "../Constant";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faSearch } from "@fortawesome/free-solid-svg-icons";
import { connect } from "react-redux";
import config from "../config";
import {
    INCREASE_NOTIFICATION,
    START_LOADER,
    STOP_LOADER,
} from "../redux/actions/types";
import {GetNotificationsAction, ReadAllNotificationAction} from "../redux/actions/notifications";
import moment from "moment";
import Pusher from "pusher-js";
import Swal from "sweetalert2";
import { LogoutAction } from "../redux/actions/auth";
Pusher.logToConsole = false;
let pusherInstance = null;

function Header({
    services,
    auth,
    logout,
    getNotifications,
    notifications,
    notificationsCounter,
    readAllNotifications,
    increaseNotification,
    startLoading,
    stopLoading,
}) {

    let notificationsChannel = null;
    let jobChannel = null;
    const navigate = useNavigate();

    const readAll = async () => {
        readAllNotifications();
        navigate('/notification');
    }

    useEffect(() => {
        // stopLoading();
        if (auth.loggedIn) {
            setupThings();
        }
        return () => {
            if (notificationsChannel) {
                notificationsChannel.unbind_all();
                pusherInstance.unsubscribe("notifications." + auth.user.id);
            }
            if (jobChannel) {
                jobChannel.unbind_all();
                pusherInstance.unsubscribe("job");
            }
        };
    }, [auth]);

    const setupThings = async () => {
        try {
            await getNotifications();
            pusherInstance = new Pusher(config.pusher.key, {
                cluster: config.pusher.cluster,
            });
            let jobChannel = pusherInstance.subscribe("job");
            jobChannel.bind("pusher:subscription_succeeded", async () => {
                jobChannel.bind("App\\Events\\JobEvent", async (data) => {
                    let job = data.message.job;
                    console.log("Job Pusher",job);
                    let schedule_id = data.message.schedule_id;
                    let schedule = job.schedule.filter(
                        (singleSchedule) => singleSchedule.id == schedule_id
                    );
                    if (schedule.length > 0) {
                        console.log("Schedule",schedule[0].status);
                        if (
                            job.user_id == auth.user.id &&
                            schedule[0].status ==
                                config.jobConstants.PENDING_ON_USER_CONFIRMATION
                        ) {
                            const result = await Swal.fire({
                                icon: "info",
                                title: `Start Job?`,
                                text: `${job.care_giver.full_name} has requested to start the job.`,
                                showCancelButton: true,
                                showConfirmButton: true,
                            });
                            if (result.isConfirmed) {
                                await startLoading();
                                const res = await config.getApi(
                                    config.services.startJobCustomer(
                                        job.id,
                                        schedule_id
                                    ),
                                    config.bearerHeaders(auth.token)
                                );
                                stopLoading();
                                if (res) {
                                    Swal.fire({
                                        title: "Job Started",
                                        text: "Job Started!",
                                        icon: "success",
                                    });
                                }
                            }
                        }
                    }
                });
            });
            let notificationsChannel = pusherInstance.subscribe(
                "notifications." + auth.user.id
            );
            notificationsChannel.bind("App\\Events\\NotificationEvent", (e) => {
                console.log("Noti",e);
                if (e.notification && e.send_to == auth.user.id) {
                    getNotifications();
                    increaseNotification();
                }
            });
        } catch (e) {
            stopLoading();
            console.log(e);
        }
    };

    return (
        <>
            {/* <audio id="xyz" src="./sound/alert-sound.wav" preload="auto"></audio> */}
            <div
                className="container-fuild"
                style={{
                    paddingLeft: "30px",
                    paddingRight: "30px",
                    paddingTop: "5px",
                    paddingBottom: "5px",
                }}
            >
                <nav id="logout-refresh" className="navbar navbar-expand-lg  ">
                    <Link to="/" className="navbar-brand">
                        <img className="main-logo" src={logo} />
                    </Link>
                    <button
                        className="navbar-toggler navbar-toggler-right"
                        type="button"
                        data-toggle="collapse"
                        data-target="#navb"
                    >
                        <FontAwesomeIcon icon={faBars} />
                    </button>

                    <div className="collapse navbar-collapse" id="navb">
                        <ul className="navbar-nav mr-auto">
                            <li className="nav-item">
                                <div className="dropdown">
                                    <button
                                        className="btn-secondary dropdown-toggle menu-links"
                                        type="button"
                                        id="dropdownMenuButton"
                                        data-toggle="dropdown"
                                        aria-haspopup="true"
                                        aria-expanded="false"
                                    >
                                        Services
                                    </button>
                                    <div
                                        className="dropdown-menu"
                                        aria-labelledby="dropdownMenuButton"
                                    >
                                        {services.map((service) => (
                                            <Link
                                                key={service.id.toString()}
                                                to={`/care-giver/${service.id}`}
                                                className="dropdown-item"
                                            >
                                                {service.title}
                                            </Link>
                                        ))}
                                    </div>
                                </div>
                            </li>
                            <li className="nav-item">
                                <Link to="/all-booking" className="nav-link">
                                    My Booking
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link to="/about-us" className="nav-link">
                                    About Us
                                </Link>
                            </li>
                            <li className="nav-item d-none">
                                <a className="nav-link" href="#">
                                    Support
                                </a>
                            </li>
                        </ul>
                        {auth.user?.email ? (
                            <ul className="navbar-nav">
                                <li className="nav-item">
                                    <Link to="/all-chat" className="nav-link">
                                        <img
                                            className="chat-img chat-img1"
                                            src={chat}
                                            height="30"
                                        />
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <div className="dropdown notifications">
                                        <button
                                            onClick={readAll}
                                            className="btn btn-secondary dropdown-toggle"
                                            type="button"
                                            id="dropdownMenuButton"
                                            data-toggle="dropdown"
                                            aria-haspopup="true"
                                            aria-expanded="false"
                                        >
                                            <img
                                                className="notification-bell notify-status"
                                                src={notification}
                                                height="30"
                                            />
                                            {notificationsCounter > 0 ? (
                                                <span className="badge badge-danger count">
                                                    {notificationsCounter}
                                                </span>
                                            ) : null}
                                        </button>
                                        <div
                                            className="dropdown-menu"
                                            aria-labelledby="dropdownMenuButton"
                                        >
                                            <div className="top_bar">
                                                <div className="noti_counts">
                                                    {/*{notificationsCounter >*/}
                                                    {/*0 ? (*/}
                                                    {/*    <span className="count">*/}
                                                    {/*        {*/}
                                                    {/*            notificationsCounter*/}
                                                    {/*        }*/}
                                                    {/*    </span>*/}
                                                    {/*) : null}*/}
                                                    <span className="count">{notificationsCounter}</span>
                                                    <h6>Notifications</h6>
                                                </div>
                                                {/* <div className="read_btn">
                                                    <button>
                                                        Mark All Read
                                                    </button>
                                                </div> */}
                                            </div>
                                            <div className="dropdown-item">
                                                {/* <a href="#"> */}
                                                <div className="all_notifications">
                                                    {notifications.data.map(
                                                        (
                                                            singleNotification
                                                        ) => (
                                                            <Link
                                                                key={
                                                                    singleNotification.id
                                                                }
                                                                to={
                                                                    singleNotification?.job_id
                                                                        ? `/job-detail/${singleNotification.job_id}`
                                                                        : `/notification`
                                                                }
                                                            >
                                                                <div className="notifications_dv">
                                                                    <div className="image_and_name">
                                                                        <figure>
                                                                            <img
                                                                                style={{
                                                                                    height: 50,
                                                                                    width: 50,
                                                                                }}
                                                                                src={
                                                                                    singleNotification.user_id ==
                                                                                    auth
                                                                                        .user
                                                                                        .id
                                                                                        ? config.returnImage(
                                                                                              singleNotification.care_giver
                                                                                          )
                                                                                        : config.returnImage(
                                                                                              singleNotification.user
                                                                                          )
                                                                                }
                                                                                alt=""
                                                                            />
                                                                        </figure>
                                                                        <div className="content">
                                                                            <h5 className="name">
                                                                                {singleNotification.user_id ==
                                                                                auth
                                                                                    .user
                                                                                    .id
                                                                                    ? singleNotification
                                                                                          .care_giver
                                                                                          .full_name
                                                                                    : singleNotification
                                                                                          .user
                                                                                          .full_name}
                                                                            </h5>
                                                                            <div className="status">
                                                                                {
                                                                                    singleNotification.description
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="time">
                                                                        <span className="day_ago">
                                                                            {moment(
                                                                                singleNotification.created_at
                                                                            ).fromNow()}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </Link>
                                                        )
                                                    )}
                                                </div>
                                                {/* </a> */}
                                                <div className="view_all_btn">
                                                    <a
                                                        onClick={readAll}
                                                        style={{
                                                            color: "var(---third-color)",
                                                            cursor : 'pointer',
                                                        }}
                                                    >
                                                        View All Notifications
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                                <li
                                    id="account"
                                    className="nav-item dropdown profile-header"
                                >
                                    <a
                                        className="nav-link "
                                        href="#"
                                        id="navbarDropdownMenuLink"
                                        role="button"
                                        data-toggle="dropdown"
                                        aria-haspopup="true"
                                        aria-expanded="false"
                                    >
                                        <div className="profile-container">
                                            <img
                                                src={config.returnImage(
                                                    auth.user
                                                )}
                                                alt=""
                                                className="image-fluid"
                                                style={{ height: "100%" }}
                                            />
                                            <span className="grey"></span>
                                        </div>
                                    </a>
                                    <div
                                        className="dropdown-menu"
                                        aria-labelledby="navbarDropdownMenuLink"
                                        data-animations="flip fadeInLeft fadeInUp fadeInRight"
                                    >
                                        <Link
                                            className="dropdown-item add-payment-card"
                                            to={"/add-card"}
                                        >
                                            Add Card
                                        </Link>
                                        <Link
                                            className="dropdown-item view-payment-card"
                                            to="/view-card"
                                        >
                                            View Card Details
                                        </Link>
                                        <Link
                                            to="/all-booking"
                                            className="dropdown-item giverAllJobs"
                                        >
                                            All Jobs
                                        </Link>
                                        <Link
                                            to="/change-password"
                                            className="dropdown-item"
                                        >
                                            Change Password
                                        </Link>
                                        <Link
                                            to="/favorites"
                                            className="dropdown-item"
                                        >
                                            Favorites
                                        </Link>
                                        <Link
                                            to="/profile"
                                            className="dropdown-item"
                                        >
                                            My Profile
                                        </Link>
                                        {auth.user.role == 2 ? (
                                            <>
                                                <Link
                                                    to="/my-services"
                                                    className="dropdown-item"
                                                >
                                                    My Services
                                                </Link>
                                                <Link
                                                    to="/documents"
                                                    className="dropdown-item"
                                                >
                                                    Documents
                                                </Link>
                                            </>
                                        ) : null}
                                        <Link
                                            to={"/wallet"}
                                            className="dropdown-item"
                                        >
                                            Wallet
                                        </Link>
                                        <a
                                            onClick={logout}
                                            href="#"
                                            className="dropdown-item"
                                            id="logout-user-btn"
                                            style={{ cursor: "pointer" }}
                                        >
                                            Log Out
                                        </a>
                                    </div>
                                </li>
                            </ul>
                        ) : (
                            <>
                                <div className="row px-3 py-3">
                                    <br />
                                    <div className="btn-element text-center d-flex">
                                        <Link
                                            to="/signup"
                                            className="orange btn btn-border padding-b find-job-btn"
                                        >
                                            Register
                                        </Link>
                                        <Link
                                            to="/signin"
                                            className="btn btn-secondary padding-b ml-2"
                                        >
                                            Sign In
                                        </Link>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </nav>
                <div className="ajax-loader">
                    <img src={preloader} className="img-responsive" />
                </div>
            </div>
            <Outlet />
        </>
    );
}

const mapStateToProps = (state) => ({
    services: state.services,
    auth: state.auth,
    notifications: state.notifications.notifications,
    // notificationsCounter: state.notifications.counter,
    notificationsCounter: state.notifications?.notifications?.data.filter(
        (val)=>val?.is_read == "0"
    )?.length,
});

const mapDispatchToProps = (dispatch) => ({
    startLoading: () => dispatch({ type: START_LOADER }),
    stopLoading: () => dispatch({ type: STOP_LOADER }),
    getNotifications: async () => dispatch(await GetNotificationsAction()),
    readAllNotifications : async () => dispatch(await ReadAllNotificationAction()),
    increaseNotification: () => dispatch({ type: INCREASE_NOTIFICATION }),
    logout: () => dispatch(LogoutAction()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);
